

















import Vue from "vue";
import Component from "vue-class-component";
import AppHeader from "@/components/Base/Header/Header.vue";
import HomeCards from "@/components/Home/Cards/Cards.vue";
import HomePoints from "@/components/Home/Points/Points.vue";
import HomeMessage from "@/components/Home/Message/Message.vue";
import MobileFacade from "@/facades/MobileFacade";
import LocationCard from "@/components/Util/LocationCard/LocationCard.vue";
import HomeDrugstores from "@/components/Home/Drugstore/Drugstores.vue";
import HomeServices from "@/components/Home/Services/Services.vue";
import { TenancyInterface } from "@/api/Interfaces/TenancyInterface";
import { ResponseInterface } from "@/api/Interfaces/ResponseInterface";
import Tenancy from "@/api/Services/Tenancy";
import axios from "@/api/axios";

import * as LogoClinicarx from "@/assets/images/Logo_nova.png";

@Component({
  name: "Home",

  components: {
    AppHeader,
    HomeCards,
    HomePoints,
    HomeMessage,
    HomeDrugstores,
    HomeServices,
    LocationCard,
  },
})
export default class Home extends Vue {
  cx_slug_id!: string;
  cx_tenancy!: TenancyInterface;
  cx_header_logo: any;
  cx_tenancy_id!: string;

  cx_isMobile = MobileFacade.isMobile();

  constructor() {
    super();
    this.cx_header_logo = LogoClinicarx;
    this.cx_tenancy_id = "";
  }

  mounted() {
    this.cx_slug_id = this.getSlugId();
    this.cx_tenancy = {} as TenancyInterface;
    this.cx_header_logo = LogoClinicarx;
    if (this.cx_slug_id != "") {
      this.getDataTenancy();
    }
  }

  getSlugId() {
    return this.$route.name == "Tenancy" ? this.$route.params.slugId : "";
  }

  getDataTenancy() {
    Tenancy.getTenancy(this.getSlugId()).then((response: any) => {
      const responseData = response as ResponseInterface;

      if (!responseData.data) {
        this.$router.push({ name: "Home" });
      } else {
        this.cx_tenancy_id = responseData.data.id;
      }

      if (this.cx_tenancy.logo_url) {
        this.verifyUrl(this.cx_tenancy.logo_url);
      }
    });
  }

  verifyUrl(url: string) {
    return new Promise(() => {
      axios
        .get(`${url}`)
        .then(() => {
          this.cx_header_logo = this.cx_tenancy.logo_url;
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }
}
